import { useInfiniteQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { type GetOrganizationsDto } from '@/types/dtos/organizations/response/get-organizations.dto.ts';
import { useAuth } from '@clerk/clerk-react';

export const GET_ORGANIZATIONS_QUERY_KEY = 'get-organizations';
const PAGE_SIZE = 5;

export const useGetOrganizationsQuery = (pageSize?: number) => {
  const { getToken } = useAuth();

  return useInfiniteQuery({
    queryKey: [GET_ORGANIZATIONS_QUERY_KEY],
    queryFn: async ({ pageParam }) => {
      const token = await getToken();
      return getOrganizations({ pageParam, pageSize, token: token ?? '' });
    },
    initialPageParam: '',
    getNextPageParam: (lastPage) => lastPage.pagination.nextCursor,
  });
};

const getOrganizations = async ({
  pageParam,
  pageSize,
  token,
}: {
  pageParam: string;
  pageSize?: number;
  token: string;
}): Promise<GetOrganizationsDto> => {
  let url = `${import.meta.env.VITE_API_URL}/organizations?limit=${pageSize ?? PAGE_SIZE}`;
  if (pageParam !== '') {
    url += `&cursor=${pageParam}`;
  }
  return sendJSONRequest({ url, method: METHOD.GET, token });
};
